export default __webpack_public_path__ + "static/media/jaslok_logo.f499f1bc.jpg";